import builtInFeaturesIcon from '../../../public/svg/icons/whyXRPLedger/BuiltInFeatures.svg';
import costsThatMakeSenseIcon from '../../../public/svg/icons/whyXRPLedger/CostsThatMakeSense.svg';
import greenBlockchainIcon from '../../../public/svg/icons/whyXRPLedger/GreenBlockchain.svg';
import speedIcon from '../../../public/svg/icons/whyXRPLedger/Speed.svg';

export const whyXRPLedgerData = {
  mainText: `Why the XRP Ledger?`,
  description: ``,
  services: [
    {
      title: 'Speed That Actually Matters',
      description:
        "The XRPL settles transactions in 3-5 seconds. When you're building payment systems or exchanges, that speed isn't a luxury - it's everything.",
      img: speedIcon,
    },
    {
      title: 'Costs That Make Sense',
      description:
        'Transaction fees cost fractions of a penny. This opens up use cases that would be economically impossible on gas-guzzling chains.',
      img: costsThatMakeSenseIcon,
    },
    {
      title: 'Green Blockchain',
      description:
        'Unlike most blockchains that require mining, the XRPL uses negligible energy, making it one of the first truly carbon-neutral blockchains.',
      img: greenBlockchainIcon,
    },
    {
      title: 'Built-In Features',
      description:
        'Native DEX, multi-currency support, escrows, and payment channels built directly into the protocol. Less code, less risk, more efficiency.',
      img: builtInFeaturesIcon,
    },
  ],
};
